var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',[_c('p',{staticClass:"text"},[_vm._v(" "+_vm._s(_setup.t( 'technology_console.widget_info_text.laser_available_vs_used_times_txt', ))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }